import { Command } from 'commands/Commands';

export class RemoveRedirect extends Command {
  type: string = 'RemoveRedirect';
  constructor(public newValue: string[]) {
    super(newValue);
  }
  priority: number = 100;
}
